<!-- AppLoader component that displays a loading indicator when the isLoading prop is true -->

<template>
  <!-- AppLoader component -->
  <v-progress-circular
    v-if="isLoading"
    indeterminate
    class="h-screen mx-auto"
  />
</template>

<script setup lang="ts">
// Prop to control the loading state
defineProps<{ isLoading: boolean }>();
</script>
